import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Card,
  Button,
  Table,
  Select,
  Input,
  Tooltip,
  Modal,
  message,
  Switch,
  Alert,
} from "antd";

import {
  req_page_eps_bloggers,
  req_edit_eps_blogger,
  req_delete_eps_blogger,
} from "../../api";

import { usrRole } from "../../utils/dataUtil";
import {
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
  CLIENT_URL,
  SYS_CODE,
} from "../../utils/contrains";

import { formateDate } from "../../utils/dateUtil";

import ManageBloggerEditModal from "./manage-blogger-edit-modal";

class ManageBloggerList extends Component {
  state = {
    loading: false,
    deviceWidth: 0,
    userLevel: "NORMAL",
    item: {},
    // 分頁參數
    items: [],
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "NA", // INTERVAL/ERROR/YET/OVER
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize.bind(this));
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const { searchField, searchValue, columnSort, orderBy, filterStatus } =
      this.state;
    const { token, role, userCode } = this.props.user;

    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_eps_bloggers(
      userLevel,
      userCode,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );
    this.setState({ loading: false });
    //console.log(result)
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
  };

  api_edit_item = async (item) => {
    const { token } = this.props.user;
    const result = await req_edit_eps_blogger(item, token);
    if (result.status === "success") {
      // message.success('異動成功')
    } else {
      //console.log(result)
    }
  };

  api_delete_item = async (key) => {
    const { token } = this.props.user;
    const result = await req_delete_eps_blogger(key, token);

    if (result.status === "success") {
      message.success("刪除成功");
      this.api_page_items(this.current);
    } else {
      //console.log(result)
    }
  };
  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "切換",
        width: 40,
        render: (item) => {
          const { BloggerCode } = item;
          const url =
            CLIENT_URL +
            "/sso?uid=" +
            btoa(BloggerCode) +
            "&sys=" +
            btoa(SYS_CODE);
          return (
            <div className="text-center">
              <a
                className="btn btn-primary btn-sm"
                href={url}
                target="_blank"
                rel="noreferrer"
                role="button"
                key={BloggerCode}
              >
                <i className="fas fa-people-arrows"></i> 登入
              </a>
            </div>
          );
        },
      },
      {
        title: "用戶分類",
        width: 80,
        render: (item) => {
          const { BlogType } = item;
          return (
            <span>{BlogType === "STUDENT" ? <>學生</> : <>教職員</>}</span>
          );
        },
      },
      {
        title: "用戶代號",
        dataIndex: "BloggerCode",
        width: 80,
      },
      {
        title: "用戶名稱",
        dataIndex: "BloggerName",
        width: 100,
      },
      {
        title: "建檔時間",
        width: 60,
        responsive: ["md"],
        render: (item) => {
          const { RecordCreateDateTime } = item;
          return <span>{formateDate(RecordCreateDateTime)}</span>;
        },
      },
      {
        title: "狀態",
        width: 60,
        render: (item) => {
          const { BlogStatus } = item;
          return (
            <span>
              <Switch
                checkedChildren="前台顯示"
                unCheckedChildren="前台關閉"
                defaultChecked={BlogStatus === "ON"}
                onChange={(e) => this.onChangeStatus(e, item)}
              />
            </span>
          );
        },
      },
      {
        title: "",
        width: 60,
        fixed: "right",
        render: (item) => {
          const { BlogUid } = item;
          const frontWebUrl = CLIENT_URL + "/blog?id=" + BlogUid;
          return (
            <span>
              <button
                type="button"
                className="btn btn-outline-dark btn-sm"
                onClick={() => this.handle_show_ui_modal("delete", item)}
              >
                <i className="fas fa-trash-alt"></i>{" "}
                <span style={{ marginLeft: "4px" }}>刪除</span>
              </button>
              <a
                className="btn btn-outline-dark btn-sm"
                href={frontWebUrl}
                target="_blank"
                rel="noreferrer"
              >
                <i className="fas fa-atlas"></i> 前台預覽
              </a>
            </span>
          );
        },
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////
  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "view":
        this.setState({ isShowModal: true, item });
        break;
      case "edit":
        this.setState({ isEditModal: true, item });
        break;
      case "add":
        this.setState({ isAddModal: true });
        break;
      case "delete":
        const { BlogUid } = item;
        Modal.confirm({
          title: `您確定永久刪除此人數位歷程檔案`,
          onOk: () => {
            this.api_delete_item(BlogUid);
          },
        });
        break;
      case "download":
        break;
      default:
    }
  };

  onChangeStatus = (e, item) => {
    const { BlogUid, BlogStatus } = item;
    const NewBlogStatus = BlogStatus === "ON" ? "OFF" : "ON";
    const tagret = {
      BlogUid: BlogUid,
      BlogStatus: NewBlogStatus,
      condition: "STATUS",
    };
    this.api_edit_item(tagret);

    const { items } = this.state;

    items.map((obj, index) => {
      if (obj.BlogUid === tagret.BlogUid) {
        obj.BlogStatus = NewBlogStatus;
      }
      return null;
    });
    this.setState(items);
  };

  /////////////////////////////////////////////////////////////
  render() {
    const { loading, items, pagination, searchField, searchValue, isAddModal } =
      this.state;
    const title = (
      <>
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="BloggerCode">職/學號</Select.Option>
          <Select.Option value="BloggerName">姓名</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 100, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}
        <Button
          type="primary"
          onClick={() => this.handle_show_ui_modal("add", {})}
        >
          <i className="fas fa-plus"></i>
          <span style={{ marginLeft: "4px" }}>增加</span>
        </Button>
      </>
    );
    return (
      <Card title={title}>
        <Alert
          message={<>若<span style={{backgroundColor:'yellow'}}>功能清單</span>未切換為<span style={{backgroundColor:'yellow'}}>使用者</span>目錄模式，請多按一次<button disabled className="btn btn-sm btn-primary"> <i className="fas fa-people-arrows"></i> 登入</button>按鈕</>}
          type="error"
        />
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="BlogUid"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
        <Modal
          destroyOnClose={true}
          visible={isAddModal}
          onOk={() => {
            this.setState({ isAddModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isAddModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <ManageBloggerEditModal />
        </Modal>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(ManageBloggerList);
